export class LegalRepresentative {
  id: number;
  canEditInformation: boolean;
  canViewInformation: boolean;
  canChangeSupplierContract: boolean;
  status: string;
  cnp: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  identityDocumentRef: string;
  isDraft: boolean;
}
